import { render } from "./app-link.vue?vue&type=template&id=6dc868ea"
import script from "./app-link.vue?vue&type=script&setup=true&lang=js"
export * from "./app-link.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/app-link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6dc868ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6dc868ea', __exports__)) {
    console.log('reload')
    api.reload('6dc868ea', __exports__)
  }
  
  module.hot.accept("./app-link.vue?vue&type=template&id=6dc868ea", () => {
    console.log('re-render')
    api.rerender('6dc868ea', render)
  })

}


export default __exports__